import axios from 'axios'

export default {
  namespaced: true,
  state: {
    associations: [],
    etablissements: [],
  },
  mutations: {
    ADD_ASSOCIATION(state, _association) {
      state.associations.push(_association)
    },
    SET_ASSOCIATIONS(state, _associations) {
      state.associations = _associations
    },
    ADD_ETABLISSEMENT(state, _etablissement) {
      state.etablissements.push(_etablissement)
    },
    UPDATE_ETABLISSEMENT(state, _etablissement) {
      for (let i = 0; i < state.etablissements.length; i++) {
        if (state.etablissements[i].etablissementId === _etablissement.etablissementId) {
          state.etablissements.splice(i, 1, _etablissement)
          break
        }
      }
    },
    SET_ETABLISSEMENTS(state, _etablissements) {
      state.etablissements = _etablissements
    },
  },
  getters: {
    getEtablissementById: (state) => (_etablissementId) => {
      return state.etablissements.find((etablissement) => etablissement.etablissementId === _etablissementId)
    },
    getSelectableEtablissements: (state) => {
      return (
        state.etablissements
          /*.filter(
          (et) =>
            rootGetters['security/isInRole']('SALARIE_' + et.etablissementId) ||
            rootGetters['security/isInRole']('SALARIE_' + et.siegeSocialId)
        )*/
          .sort(function (sA, sB) {
            return sA.etablissementId - sB.etablissementId
          })
      )
    },
    getEtablissements(state) {
      return state.etablissements.sort(function (sA, sB) {
        return sA.etablissementId - sB.etablissementId
      })
    },
    getAssociations(state) {
      return state.associations.sort(function (sA, sB) {
        return sA.associationId - sB.associationId
      })
    },
    getAssociationById: (state) => (_associationId) => {
      return state.etablissements.find((association) => association.associationId === _associationId)
    },
  },
  actions: {
    //Utilisé indirectement dans security.js:55
    fetchEtablissements({ commit }) {
      return axios.get(`${process.env.VUE_APP_URL_BACK_SERENITY}/etablissement`).then((response) => {
        commit('SET_ETABLISSEMENTS', response.data)
        if (response.data.length === 1) {
          this.dispatch('application/selectEtablissement', response.data[0])
        }
      })
    },
    //Utilisé indirectement dans security.js:56
    fetchAssociations({ commit }) {
      return axios.get(`${process.env.VUE_APP_URL_BACK_SERENITY}/etablissement/association`).then((response) => {
        commit('SET_ASSOCIATIONS', response.data)
      })
    },
    // eslint-disable-next-line no-empty-pattern
    fetchBudget({}, _associationId) {
      const anneeDemandee = new Date().getFullYear() + 1
      return axios
        .get(
          `${process.env.VUE_APP_URL_BACK_SERENITY}/etablissement/association/${_associationId}/budget_heures_supp_jour_ferie_annuel.csv?_annee=${anneeDemandee}`
        )
        .then((response) => {
          const blob = new Blob([response.data], { type: 'text/csv' })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = 'budget_heures_supp_jour_ferie_annuel.csv'
          link.click()
          URL.revokeObjectURL(link.href)
        })
        .catch(console.error)
    },
    // eslint-disable-next-line no-empty-pattern
    fetchBudgetDimanche({}, _heuresDuDimancheQuery) {
      return axios
        .get(
          `${process.env.VUE_APP_URL_BACK_SERENITY}/etablissement/association/${_heuresDuDimancheQuery.associationId}/budget_dimanche.csv?date=${_heuresDuDimancheQuery.dimancheABudgeter}`
        )
        .then((response) => {
          const blob = new Blob([response.data], { type: 'text/csv' })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = 'budget_dimanche.csv'
          link.click()
          URL.revokeObjectURL(link.href)
        })
        .catch(console.error)
    },
    // eslint-disable-next-line no-empty-pattern
    obtenirFicheDePresenceADate({}, { _etablissementId, _date }) {
      return axios.get(`${process.env.VUE_APP_URL_BACK_SERENITY}/etablissement/${_etablissementId}/ficheDePresence`, {
        params: {
          dateDeProspection: _date,
        },
      })
    },

    // eslint-disable-next-line no-empty-pattern
    obtenirLeNumeroDastreinteActuellement({}, _etablissementId) {
      return axios
        .get(`${process.env.VUE_APP_URL_BACK_SERENITY}/etablissement/${_etablissementId}/numero-astreinte`)
        .then((response) => response.data)
    },
    createAssociation({ commit }, _toCreate) {
      return axios
        .post(`${process.env.VUE_APP_URL_BACK_SERENITY}/etablissement/association`, _toCreate)
        .then((response) => {
          commit('ADD_ASSOCIATION', response.data)
        })
    },
    createEtablissement({ commit }, _toCreate) {
      return axios.post(`${process.env.VUE_APP_URL_BACK_SERENITY}/etablissement`, _toCreate).then((response) => {
        commit('ADD_ETABLISSEMENT', response.data)
      })
    },
    updateDirecteurEtablissement({ commit }, _command) {
      return axios
        .put(`${process.env.VUE_APP_URL_BACK_SERENITY}/etablissement/${_command.etablissementId}/directeur`, _command)
        .then((response) => {
          commit('UPDATE_ETABLISSEMENT', response.data)
        })
    },
    exportPaye(state, _exportPayeCommand) {
      return axios
        .get(
          `${process.env.VUE_APP_URL_BACK_SERENITY}/etablissement/${_exportPayeCommand.etablissementId}/export_elements_paye.csv?_dateDebut=${_exportPayeCommand.dateDebut}&_dateFin=${_exportPayeCommand.dateFin}`
        )
        .then((response) => {
          const blob = new Blob([response.data], { type: 'text/csv' })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = 'export_elements_paye.csv'
          link.click()
          URL.revokeObjectURL(link.href)
        })
        .catch(console.error)
    },
    exportAnnualisation(state, _exportAnnualisationCommand) {
      return axios
        .get(
          `${process.env.VUE_APP_URL_BACK_SERENITY}/annualisation/etablissement/${_exportAnnualisationCommand.id}?_annee=${_exportAnnualisationCommand.annee}`,
          { responseType: 'blob' }
        )
        .then((response) => {
          const link = document.createElement('a')
          link.href = URL.createObjectURL(response.data)
          link.download = 'document.pdf'
          link.click()
          URL.revokeObjectURL(link.href)
        })
        .catch(console.error)
    },
    async obtenirListeComptablesEtablissement(state, _etablissementId) {
      return await axios
        .get(`${process.env.VUE_APP_URL_BACK_SERENITY}/etablissement/${_etablissementId}/comptable`)
        .then((response) => {
          return {
            estReussi: response.status === 200,
            comptables: response.data,
          }
        })
    },
    async ajouterUnComptableAEtablissement(state, _ajouterUnComptableAEtablissementCommand) {
      await axios
        .post(
          `${process.env.VUE_APP_URL_BACK_SERENITY}/etablissement/${_ajouterUnComptableAEtablissementCommand.etablissementId}/comptable`,
          _ajouterUnComptableAEtablissementCommand
        )
        .then((response) => {
          return response.status === 200
        })
    },
    async retirerUnComptableAEtablissement(state, _retirerUnComptableAEtablissementCommand) {
      await axios
        .delete(
          `${process.env.VUE_APP_URL_BACK_SERENITY}/etablissement/${_retirerUnComptableAEtablissementCommand.etablissementId}/comptable`,
          {
            data: _retirerUnComptableAEtablissementCommand,
          }
        )
        .then((response) => {
          return response.status === 200
        })
    },
    async obtenirHorairesDesRepas(state, _etablissementId) {
      return await axios
        .get(`${process.env.VUE_APP_URL_BACK_SERENITY}/etablissement/${_etablissementId}/horaires-repas`)
        .then((value) => value.data)
    },
    async modifierHorairesDesRepas(state, _modifierHorairesDesRepas) {
      return await axios
        .put(
          `${process.env.VUE_APP_URL_BACK_SERENITY}/etablissement/${_modifierHorairesDesRepas.etablissementId}/horaires-repas`,
          _modifierHorairesDesRepas
        )
        .then((value) => value.data)
    },
    async obtenirPrevisionsRepasPourDate(state, _obtenirPrevisionsRepasPourDateCommand) {
      return await axios
        .get(
          `${process.env.VUE_APP_URL_BACK_SERENITY}/etablissement/${_obtenirPrevisionsRepasPourDateCommand.etablissementId}/previsionRepas`,
          {
            params: { dateDeProspection: _obtenirPrevisionsRepasPourDateCommand.dateDeProspection },
          }
        )
        .then((value) => value.data)
    },
    async obtenirListeDispositifsEtablissement(state, _etablissementId) {
      return await axios
        .get(`${process.env.VUE_APP_URL_BACK_SERENITY}/etablissement/${_etablissementId}/dispositifs`)
        .then((response) => {
          return {
            estReussi: response.status === 200,
            dispositifs: response.data,
          }
        })
    },
    async ajouterDispositif(state, _ajouterDispositifCommand) {
      await axios
        .post(
          `${process.env.VUE_APP_URL_BACK_SERENITY}/etablissement/${_ajouterDispositifCommand.etablissementId}/dispositifs`,
          _ajouterDispositifCommand.dispositif
        )
        .then((response) => {
          return response.status === 200
        })
    },
    async retirerUnDispositif(state, { _etablissementId, _dispositifId }) {
      await axios
        .delete(
          `${process.env.VUE_APP_URL_BACK_SERENITY}/etablissement/${_etablissementId}/dispositifs/${_dispositifId}`
        )
        .then((response) => {
          return response.status === 200
        })
    },
  },
}
